const VersionInfo = {
	version: "1.7.1",
	major: 1,
	minor: 7,
	patch: 1,
	suffix: "",
	isNext: false,
	buildTime: 1664265279,
};
export default VersionInfo;